import {useState, useCallback, useContext} from 'react'
import {getAuthHeader, getLocalStorageItem, objectLang, setErrorWindow, setLocalStorageItem} from "../functions"
import config from "../config.json"
import {AuthContext} from "../context/AuthContext"
import {useNavigate} from "react-router-dom"

export const useHttp = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const l = objectLang().language.lang
    const auth = useContext(AuthContext)
    const navigate = useNavigate()

    const request = useCallback(async (url, method = 'GET', body = null, headers = {}, load = true) => {
            setLoading(load)
            try {
                if (body) {
                    body = JSON.stringify(body)
                    headers['Content-Type'] = 'application/json'

                }
                let response = await fetch(url, {method, body, headers, credentials: 'include'})
                let data = await response.json()

                if (!response.ok) {
                    if (!auth && data.code === 6042) {
                        navigate(`/${l}/`, { replace: true })
                    }
                    if (data.code === 6041) {
                        setLoading(true)
                        let host
                        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
                        const refreshTokenResp = await fetch(`${host}/api/user/refresh`, {
                            method: "get",
                            body: null,
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: getAuthHeader(auth)
                            },
                            credentials: 'include'
                        })
                        const refreshData = await refreshTokenResp.json()
                        if (!auth && data.code === 6042) {
                            navigate(`/${l}/`, { replace: true })
                        }
                        const userData = getLocalStorageItem('userData')
                        if (auth && refreshData.accessToken && auth.accessToken !== refreshData.accessToken) {
                            userData.accessToken = refreshData.accessToken
                            setLocalStorageItem('userData', userData)
                            auth.accessToken = refreshData.accessToken
                        }
                        if (refreshTokenResp.ok) {
                            response = await fetch(url, {
                                method,
                                body,
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: getAuthHeader(auth)
                                },
                                credentials: 'include'})
                            data = await response.json()
                            setLoading(false)
                            return data
                        } else {
                            setErrorWindow('', 6042)
                            window.location.replace(`/${l}/modal`)
                        }
                    } else {
                        setLoading(false)
                        return data
                    }
                    setLoading(false)
                    setError(data.message)
                    localStorage.removeItem('userData')
                    window.location.replace(`/${l}/`)
                }
                setLoading(false)
                return data

            } catch
                (e) {
                setLoading(false)
                setError(e.message)
                throw e
            }
        }, [auth, l, navigate]
    )

    const clearError = useCallback(() => setError(null), [])

    return {loading, request, error, clearError}
}
